import { render } from "./LoadingContent.vue?vue&type=template&id=2c4a081e"
import script from "./LoadingContent.vue?vue&type=script&lang=js"
export * from "./LoadingContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__